// components/OTPVerification.tsx
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

interface OTPVerificationProps {
  email: string;
}

const OTPVerification: React.FC<OTPVerificationProps> = ({ email }) => {
  const { verifyOTP } = useAuth();
  const [otp, setOtp] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await verifyOTP(email, otp);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f5f5 0%, #e5e7eb 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: 'Inter, sans-serif'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        background: 'rgba(255,255,255,0.28)',
        backdropFilter: 'blur(18px)',
        padding: '42px',
        borderRadius: '22px',
        boxShadow: '0 18px 35px rgba(0,0,0,0.15)',
        border: '1.5px solid rgba(255,255,255,0.4)'
      }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: 900,
          color: '#2563eb',
          textAlign: 'center',
          margin: '0 0 18px 0',
          fontFamily: "'Montserrat', 'Segoe UI', 'Roboto', Arial, sans-serif",
          letterSpacing: '2px'
        }}>
          Enter OTP
        </h1>

        <p style={{
          fontSize: '16px',
          color: '#111',
          margin: '0 0 30px 0',
          fontWeight: 600,
          textAlign: 'center',
          fontFamily: "'Montserrat', 'Segoe UI', 'Roboto', Arial, sans-serif"
        }}>
          We sent a verification code to<br />
          <strong>{email}</strong>
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '24px' }}>
          <div>
            <label style={{ fontWeight: 700, color: '#1f2937', marginBottom: '6px', display: 'block' }}>
              6-Digit Code
            </label>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="123456"
              required
              maxLength={6}
              style={{
                width: '100%',
                padding: '14px 16px',
                border: error ? '2px solid #f87171' : '1.6px solid #bfdbfe',
                borderRadius: '10px',
                fontSize: '20px',
                outline: 'none',
                background: 'rgba(255,255,255,0.85)',
                textAlign: 'center',
                letterSpacing: '4px',
                fontWeight: 700,
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={isLoading || otp.length !== 6}
            style={{
              padding: '14px 0',
              background: isLoading || otp.length !== 6 ? '#93c5fd' : '#1e40af',
              color: 'white',
              borderRadius: '10px',
              fontWeight: 800,
              fontSize: '18px',
              border: 'none',
              cursor: isLoading || otp.length !== 6 ? 'not-allowed' : 'pointer',
              boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
            }}
          >
            {isLoading ? 'Verifying...' : 'Verify Code'}
          </button>
        </form>

        {error && (
          <div style={{
            marginTop: '16px',
            background: '#fee2e2',
            padding: '12px',
            borderRadius: '10px',
            color: '#b91c1c',
            fontWeight: 800,
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default OTPVerification;